<template>
    <div class="containerPrivacy">
        <b-container class="container-privacy-application">
            <b-row class="mb-20 privacy-title">
                ПОЛИТИКА В ОБЛАСТИ ОБРАБОТКИ И ЗАЩИТЫ ПЕРСОНАЛЬНЫХ ДАННЫХ
            </b-row>

            <b-row class="mb-20 privacy-text-header">
                1. Назначение политики 
            </b-row>

            <b-row class="mb-20 privacy-text">
            Настоящая Политика определяет принципы и условия обработки персональных данных, 
            а также реализуемые меры по защите персональных данных в ООО «Май-Фудс».
            </b-row>

            <b-row class="mb-20 privacy-text-header">
                2. Область примененения
            </b-row>

            <b-row class="mb-20 privacy-text">
                Настоящая Политика предназначена для ознакомления неограниченным кругом лиц, путем размещения на сайтах Обществ МАЙ. 
                Настоящая Политика распространяется на все подразделения ООО «Май-Фудс».      
            </b-row>

            <b-row class="mb-20 privacy-text-header">
                3. Термины и сокращения
            </b-row>
            
            <b-row class="mb-20 privacy-text-header">
                3.1  Термины и определения
            </b-row>
            
            <b-table-simple hover small caption-top responsive class="table-bordered">
                <b-thead head-variant="dark">
                <b-tr>
                    <b-th>Термин</b-th>
                    <b-th>Определение</b-th>
                </b-tr>
                </b-thead>
                <b-tbody>
                <b-tr>
                    <b-th>Персональные данные</b-th>
                    <b-td>Любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных)</b-td>
                </b-tr>
                <b-tr>
                    <b-th>Оператор персональных данных (оператор)</b-th>
                    <b-td>Государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных, 
                        а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-th>Обработка персональных данных</b-th>
                    <b-td>Любое действие (операция) или совокупность действий (операций) с персональными данными, совершаемых с использованием средств автоматизации или без их использования. 
                        Обработка персональных данных включает в себя, в том числе: сбор; запись; систематизацию; накопление; хранение; уточнение (обновление, изменение); извлечение; использование; передачу (распространение, предоставление, доступ); обезличивание; блокирование; удаление; уничтожение
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-th>Автоматизированная обработка персональных данных</b-th>
                    <b-td>Обработка персональных данных с помощью средств вычислительной техники</b-td>
                </b-tr>
                <b-tr>
                    <b-th>Распространение персональных данных</b-th>
                    <b-td>Действия, направленные на раскрытие персональных данных неопределенному кругу лиц</b-td>
                </b-tr>
                <b-tr>
                    <b-th>Предоставление персональных данных</b-th>
                    <b-td>Действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц</b-td>
                </b-tr>
                <b-tr>
                    <b-th>Блокирование персональных данных</b-th>
                    <b-td>Временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных)</b-td>
                </b-tr>
                <b-tr>
                    <b-th>Уничтожение персональных данных</b-th>
                    <b-td>Действия, в результате которых становится невозможным восстановить содержание персональных данных в информационной системе персональных данных и (или) в результате которых уничтожаются материальные носители персональных данных</b-td>
                </b-tr>
                <b-tr>
                    <b-th>Обезличивание персональных данных</b-th>
                    <b-td>Действия, в результате которых становится невозможным без использования дополнительной информации определить принадлежность персональных данных конкретному субъекту персональных данных</b-td>
                </b-tr>
                <b-tr>
                    <b-th>Информационная система персональных данных</b-th>
                    <b-td>Совокупность содержащихся в базах данных персональных данных и обеспечивающих их обработку информационных технологий и технических средств</b-td>
                </b-tr>
                <b-tr>
                    <b-th>Трансграничная передача персональных данных</b-th>
                    <b-td>Передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому лицу или иностранному юридическому лицу</b-td>
                </b-tr>
                </b-tbody>
            </b-table-simple>

            <b-row class="mb-20 privacy-text-header">
                3.2  Сокращения и расшифровки
            </b-row>

            <b-table-simple hover small caption-top responsive class="table-bordered">
                <b-thead head-variant="dark">
                <b-tr>
                    <b-th>Сокращение</b-th>
                    <b-th>Расшифровка</b-th>
                </b-tr>
                </b-thead>
                <b-tbody>
                <b-tr>
                    <b-th>ИБ</b-th>
                    <b-td>Информационная безопасность</b-td>
                </b-tr>
                <b-tr>
                    <b-th>ИСПДн</b-th>
                    <b-td>Информационная система персональных данных</b-td>
                </b-tr>
                <b-tr>
                    <b-th>Общество</b-th>
                    <b-td>Общество с ограниченной ответственностью «Май-Фудс»</b-td>
                </b-tr>
                </b-tbody>
            </b-table-simple>

            <b-row class="mb-20 privacy-text-header">
                4.1  Цели и задачи Политики
            </b-row>

            <b-row class="mb-20 privacy-text">
                Основными целями Политики являются:     
            </b-row>

            <b-list-group class="mb-20">
                <b-list-group-item>
                    организация обработки и защиты персональных данных в 
                    Обществе в соответствии с требованиями законодательства РФ, нормативными и методическими документами в области ИБ;
                </b-list-group-item>
                <b-list-group-item>
                    обеспечение соблюдения Обществом прав субъектов персональных данных.
                    Достижение указанных целей обеспечивается выполнением следующих задач:
                </b-list-group-item>
                <b-list-group-item>
                    издание локальных нормативных актов, регламентирующих порядок обработки и защиты персональных данных в Обществе;
                </b-list-group-item>
                <b-list-group-item>
                    применение организационных и технических мер по обеспечению безопасности обрабатываемых персональных данных;
                </b-list-group-item>
                <b-list-group-item>
                    обучение работников Общества правилам обработки персональных данных и обеспечения ИБ;
                </b-list-group-item>
                <b-list-group-item>
                    организация взаимодействия с субъектами персональных данных;
                </b-list-group-item>
                <b-list-group-item>
                    регулярный контроль соответствия процессов обработки и защиты персональных данных требованиям законодательства РФ, 
                    нормативным и методическим документам в области ИБ.
                </b-list-group-item>
            </b-list-group>

            <b-row class="mb-20 privacy-text-header">
                5. Принципы обработки персональных данных
            </b-row>

            <b-row class="mb-20 privacy-text">
                Обработка персональных данных в Обществе осуществляется с соблюдением принципов и правил, установленных законодательством Российской Федерации:     
            </b-row>

            <b-list-group class="mb-20">
                <b-list-group-item>
                    обработка персональных данных осуществляется на законной и справедливой основе;
                </b-list-group-item>
                <b-list-group-item>
                    обработка персональных данных ограничивается достижением конкретных, заранее определенных и законных целей
                </b-list-group-item>
                <b-list-group-item>
                    не допускается обработка персональных данных, несовместимая с целями сбора персональных данных;
                </b-list-group-item>
                <b-list-group-item>
                    обработке подлежат только персональные данные, которые отвечают целям их обработки;
                </b-list-group-item>
                <b-list-group-item>
                    содержание и объем обрабатываемых персональных данных соответствуют заявленным целям обработки;
                </b-list-group-item>
                <b-list-group-item>
                    при обработке персональных данных обеспечивается точность, актуальность, достаточность персональных данных по отношению к целям обработки персональных данных, 
                    а также принимаются необходимые меры по уточнению или удалению неполных или неточных данных;
                </b-list-group-item>
                <b-list-group-item>
                    хранение персональных данных осуществляется в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, 
                    федеральные законы, договоры, стороной которого являются субъекты персональных данных;
                </b-list-group-item>
                <b-list-group-item>
                    обрабатываемые персональные данные подлежат уничтожению по достижении целей 
                    обработки или в случае утраты необходимости в достижении этих целей, если иное не предусмотрено законодательством Российской Федерации.
                </b-list-group-item>
            </b-list-group>

            <b-row class="mb-20 privacy-text-header">
                6. Субъекты персональных данных и состав обрабатываемых персональных данных
            </b-row>

            <b-row class="mb-20 privacy-text-header">
                6.1 Субъекты персональных данных
            </b-row>

            <b-row class="mb-20 privacy-text">
                К основным категориям субъектов персональных данных, чьи данные обрабатываются в Обществе, относятся:     
            </b-row>

            <b-list-group class="mb-20">
                <b-list-group-item>
                    соискатели на вакантные должности Общества, их рекомендатели;
                </b-list-group-item>
                <b-list-group-item>
                    работники, состоящие или состоявшие в трудовых отношениях с Обществом;
                </b-list-group-item>
                <b-list-group-item>
                    близкие родственники работников Общества;
                </b-list-group-item>
                <b-list-group-item>
                    работники юридических лиц ООО «МАЙ», ООО «Май-Брендс», ООО Компания «МАЙ», ООО «Май-Риэлти», ООО «Май24» (далее – Общества МАЙ);
                </b-list-group-item>
                <b-list-group-item>
                    члены Совета директоров, члены Правления Обществ МАЙ;
                </b-list-group-item>
                <b-list-group-item>
                    контрагенты (физические лица, индивидуальные предприниматели, представители юридических лиц, состоящие или состоявшие в гражданско-правовых отношениях с Обществом);
                </b-list-group-item>
                <b-list-group-item>
                    действующие и потенциальные потребители, участники рекламных акций и мероприятий, пользователи интернет-сайтов Обществ МАЙ;
                </b-list-group-item>
                <b-list-group-item>
                    посетители Общества.
                </b-list-group-item>
            </b-list-group>

            <b-row class="mb-20 privacy-text-header">
                6.2 Состав обрабатываемых персональных данных
            </b-row>

            <b-row class="mb-20 privacy-text">
                Состав обрабатываемых персональных данных и способы обработки персональных данных для каждой категории субъектов персональных данных определены Перечнем обрабатываемых персональных данных, утвержденным Обществом.     
            </b-row>

            <b-row class="mb-20 privacy-text">
                В Обществе не допускается обработка следующих категорий персональных данных:     
            </b-row>

            <b-list-group class="mb-20">
                <b-list-group-item>
                    расовая принадлежность;
                </b-list-group-item>
                <b-list-group-item>
                    национальная принадлежность;
                </b-list-group-item>
                <b-list-group-item>
                    политические взгляды;
                </b-list-group-item>
                <b-list-group-item>
                    философские убеждения;
                </b-list-group-item>
                <b-list-group-item>
                    состояние интимной жизни;
                </b-list-group-item>
                <b-list-group-item>
                    религиозные убеждения.
                </b-list-group-item>
            </b-list-group>

            <b-row class="mb-20 privacy-text">
                В Обществе не обрабатываются биометрические персональные данные (сведения, которые характеризуют физиологические и биологические особенности человека, на основании которых можно установить его личность).
            </b-row>

            <b-row class="mb-20 privacy-text">
                Сведения о состоянии здоровья работника Общества, которые относятся к возможности исполнять работником свои трудовые функции, обрабатываются исключительно в случаях, предусмотренных Трудовым кодексом РФ.     
            </b-row>

            <b-row class="mb-20 privacy-text">
                В Обществе не осуществляется обработка данных о судимости субъектов персональных данных.
            </b-row>

            <b-row class="mb-20 privacy-text-header">
                7. Цели обработки персональных данных
            </b-row>

            <b-row class="mb-20 privacy-text">
                Обработка персональных данных осуществляется Обществом в следующих целях:
            </b-row>

            <b-list-group class="mb-20">
                <b-list-group-item>
                    подбор персонала на вакантные должности Обществ МАЙ;
                </b-list-group-item>
                <b-list-group-item>
                    ведение кадрового делопроизводства, бухгалтерского, налогового учета, исполнение обязательств Обществом, предусмотренных трудовыми договорами и законодательством Российской Федерации;
                </b-list-group-item>
                <b-list-group-item>
                    оформление банковской карты и /или прикрепление работника к зарплатному проекту, полисов добровольного медицинского страхования, страхования от несчастных случаев;
                </b-list-group-item>
                <b-list-group-item>
                    оформление доверенностей на представление интересов Общества;
                </b-list-group-item>
                <b-list-group-item>
                    оформление работникам сертификатов ключей электронной подписи в удостоверяющих центрах;
                </b-list-group-item>
                <b-list-group-item>
                    организация и проведение корпоративного обучения, содействие работникам в повышении квалификации;
                </b-list-group-item>
                <b-list-group-item>
                    предоставление служебного автотранспорта;
                </b-list-group-item>
                <b-list-group-item>
                    оформление визитных карточек работников;
                </b-list-group-item>
                <b-list-group-item>
                    создание и ведение справочников корпоративных информационных систем, информационное обеспечение деятельности на интернет-сайтах Обществ МАЙ и на страницах в социальных сетях;
                </b-list-group-item>
                <b-list-group-item>
                    заключение, исполнение, расторжение договоров с контрагентами;
                </b-list-group-item>
                <b-list-group-item>
                    исполнение актов органов государственной власти;
                </b-list-group-item>
                <b-list-group-item>
                    осуществление электронных рассылок информационного, маркетингового и рекламного характера;
                </b-list-group-item>
                <b-list-group-item>
                    организация и /или проведение маркетинговых мероприятий, рекламных акций; 
                </b-list-group-item>
                <b-list-group-item>
                    анализ, сегментирование данных о потребителях и заказах;
                </b-list-group-item>
                <b-list-group-item>
                    прием и обработка обращений, запросов, претензий потребителей и иных лиц;
                </b-list-group-item>
                <b-list-group-item>
                    повышение эффективности и удобства работы с интернет-сайтом(ами), регистрация пользователей (создание учетной записи) на сайте(ах), персонализация контента;
                </b-list-group-item>
                <b-list-group-item>
                    исполнение требований законодательства.
                </b-list-group-item>
            </b-list-group>

            <b-row class="mb-20 privacy-text-header">
                8. Правовые основания обработки персональных данных
            </b-row>

            <b-row class="mb-20 privacy-text">
                Правовыми основаниями обработки персональных данных Обществом являются:
            </b-row>

            <b-list-group class="mb-20">
                <b-list-group-item>
                    Конституция Российской Федерации;
                </b-list-group-item>
                <b-list-group-item>
                    Трудовой кодекс Российской Федерации;
                </b-list-group-item>
                <b-list-group-item>
                    Гражданский кодекс Российской Федерации;
                </b-list-group-item>
                <b-list-group-item>
                    Налоговый кодекс Российской Федерации;
                </b-list-group-item>
                <b-list-group-item>
                    Устав Общества;
                </b-list-group-item>
                <b-list-group-item>
                    согласие субъекта на обработку персональных данных;
                </b-list-group-item>
                <b-list-group-item>
                    трудовой договор;
                </b-list-group-item>
                <b-list-group-item>
                    договор с субъектом персональных данных;
                </b-list-group-item>
                <b-list-group-item>
                    Пользовательское соглашение, размещенное на интернет-сайтах Обществ МАЙ;
                </b-list-group-item>
                <b-list-group-item>
                    Федеральный закон от 06.12.2011 г. № 402-ФЗ «О бухгалтерском учете»;
                </b-list-group-item>
                <b-list-group-item>
                    Федеральный закон от 01.04.1996 г. № 27-ФЗ «Об индивидуальном (персонифицированном) учете в системе обязательного пенсионного страхования»;
                </b-list-group-item>
                <b-list-group-item>
                    Федеральный закон от 24.07.2009 г. № 212-ФЗ «О страховых взносах в Пенсионный Фонд РФ, Фонд социального страхования РФ, Федеральный Фонд обязательного медицинского страхования и территориальные фонды обязательного медицинского страхования»;
                </b-list-group-item>
                <b-list-group-item>
                    Приказ Росархива от 20.12.2019 № 236 «Об утверждении Перечня типовых управленческих архивных документов, образующихся в процессе деятельности государственных органов, органов местного самоуправления и организаций, с указанием сроков их хранения»;
                </b-list-group-item>
                <b-list-group-item>
                    Федеральный закон от 07.07.2003 г. № 126-ФЗ «О связи»;
                </b-list-group-item>
                <b-list-group-item>
                    Федеральный закон от 13.03.2006 г. № 38-ФЗ «О рекламе»;
                </b-list-group-item>
                <b-list-group-item>
                    Федеральный закон от 06.04.2011 г. № 63-ФЗ «Об электронной подписи».
                </b-list-group-item>
            </b-list-group>

            <b-row class="mb-20 privacy-text-header">
                9. Обработка персональных данных с использованием сайта
            </b-row>

            <b-row class="mb-20 privacy-text">
                Пользователям сайта(ов) может быть предложено пройти процедуру регистрации для участия в маркетинговых мероприятиях Общества посредством заполнения электронных форм сбора персональных данных. 
                Обработка персональных данных будет осуществляться Обществом только в случае проставления пользователем отметки о согласии на обработку персональных данных и принятия условий Пользовательского соглашения.
            </b-row>

            <b-row class="mb-20 privacy-text">
                Пользователь вправе отозвать согласие на обработку персональных данных путем направления электронного документа, 
                подписанного простой электронной подписью (учетных данных пользователя, указанных при регистрации на сайте) 
                на адрес электронной почты<a href="mailto:privacy@theMay.com"> privacy@theMay.com.</a> 
            </b-row>

            <b-row class="mb-20 privacy-text-header">
                10. Доступ к персональным данным
            </b-row>

            <b-row class="mb-20 privacy-text">
                Доступ к персональным данным может быть предоставлен:
            </b-row>

            <b-list-group class="mb-20">
                <b-list-group-item>
                    работникам Общества в рамках исполнения функциональных обязанностей и полномочий, 
                    закрепленных в их должностных инструкциях либо предусмотренных локальными нормативными документами Общества;
                </b-list-group-item>
                <b-list-group-item>
                    представителям органов государственной власти, контролирующих, правоохранительных и иных органов, 
                    получающим доступ к персональным данным в объеме, порядке и условиях, установленных законодательством Российской Федерации;
                </b-list-group-item>
                <b-list-group-item>
                    третьим лицам с согласия субъекта персональных данных, 
                    с целью исполнения договорных обязательств перед субъектом персональных данных, а также с целью обеспечения своей деятельности;
                </b-list-group-item>
                <b-list-group-item>
                    сторонним организациям в целях использования вычислительных ресурсов, приложений, 
                    информационной инфраструктуры для обработки информации, направления электронных рассылок информационного и маркетингового характера.
                </b-list-group-item>
            </b-list-group>

            <b-row class="mb-20 privacy-text">
                Общество может выступать как лицо, осуществляющее обработку персональных данных по поручению Обществ МАЙ.
            </b-row>

            <b-row class="mb-20 privacy-text">
                Передача или поручение обработки персональных данных сторонним организациям осуществляется на основании заключенных договоров, 
                обязательными условиями которых является обязанность по соблюдению конфиденциальности и 
                обеспечению безопасности персональных данных при их обработке, а также обязательство третьего лица использовать данные исключительно в заранее определенных целях и объемах.
            </b-row>

            <b-row class="mb-20 privacy-text">
                При передаче или поручении обработки персональных данных сторонним организациям возможны случаи осуществления трансграничной передачи. 
                В этом случае Общество следует требованиям законодательства Российской Федерации и осуществляет передачу только на территорию иностранных государств, обеспечивающих адекватную защиту прав субъектов персональных данных.
            </b-row>

            <b-row class="mb-20 privacy-text-header">
                11. Безопасность персональных данных
            </b-row>

            <b-row class="mb-20 privacy-text">
                Руководство Общества заинтересовано в обеспечении безопасности персональных данных, 
                обрабатываемых в рамках выполнения основной деятельности, как с точки зрения требований законодательства Российской Федерации, так и с точки зрения оценки рисков для бизнеса.
            </b-row>

            <b-row class="mb-20 privacy-text">
                Общество принимает необходимые правовые, организационные и технические меры для защиты персональных данных от несанкционированного 
                (в том числе, случайного) доступа, изменения, уничтожения и других несанкционированных действий, включающие в себя:
            </b-row>

            <b-list-group class="mb-20">
                <b-list-group-item>
                    назначение лиц, ответственных за организацию обработки и обеспечение безопасности персональных данных в Обществе;
                </b-list-group-item>
                <b-list-group-item>
                    утверждение локальных нормативных документов по вопросам обработки персональных данных, информационной безопасности, ознакомление с ними работников;
                </b-list-group-item>
                <b-list-group-item>
                    проведение обучающих мероприятий для работников по вопросам обработки персональных данных, обеспечения информационной безопасности;
                </b-list-group-item>
                <b-list-group-item>
                    обеспечение физической безопасности помещений и средств обработки, пропускной режим, охрана, видеонаблюдение;
                </b-list-group-item>
                <b-list-group-item>
                ограничение и разграничение доступа работников, сторонних организаций к персональным данным и средствам обработки, 
                мониторинг действий с персональными данными в информационных системах персональных данных (ИСПДн) Общества;
                </b-list-group-item>
                <b-list-group-item>
                    оценку вреда, который может быть причинен субъектам персональных данных и определение актуальных угроз безопасности персональных данных при их обработке в ИСПДн Общества;
                </b-list-group-item>
                <b-list-group-item>
                    применение средств обеспечения безопасности ИСПДн (антивирусных средств, межсетевых экранов, средств защиты от несанкционированного доступа, средств криптографической защиты информации), 
                    в том числе, в необходимых случаях прошедших процедуру оценки соответствия в установленном порядке;
                </b-list-group-item>
                <b-list-group-item>
                    учёт и хранение носителей информации, исключающее их хищение, подмену, несанкционированное копирование и уничтожение;
                </b-list-group-item>
                <b-list-group-item>
                    резервное копирование информации для возможности восстановления;
                </b-list-group-item>
                <b-list-group-item>
                    осуществление внутреннего контроля (аудита) за соблюдением установленного порядка обработки и защиты персональных данных, оценку эффективности принятых мер, реагирование на инциденты;
                </b-list-group-item>
                <b-list-group-item>
                    проверку наличия в договорах с третьими лицами и включение при необходимости в договоры пунктов об обеспечении конфиденциальности и безопасности персональных данных;
                </b-list-group-item>
                <b-list-group-item>
                    иные меры в соответствии с локальными нормативными документами Общества в области ИБ.
                </b-list-group-item>
            </b-list-group>

            <b-row class="mb-20 privacy-text-header">
                12. Права субъекта персональных данных
            </b-row>

            <b-row class="mb-20 privacy-text">
                Субъект персональных данных имеет право:
            </b-row>

            <b-list-group class="mb-20">
                <b-list-group-item>
                    получать полную информацию об обработке своих персональных данных, за исключением случаев, предусмотренных законодательством Российской Федерации;
                </b-list-group-item>
                <b-list-group-item>
                    требовать исправления неверных или неполных персональных данных, а также удаления персональных данных, обработка которых ведется с нарушением законодательства Российской Федерации;
                </b-list-group-item>
                <b-list-group-item>
                    отозвать согласие на обработку персональных данных, данное им Обществу;
                </b-list-group-item>
                <b-list-group-item>
                    обжаловать в суде любые неправомерные действия или бездействие Общества при обработке и защите персональных данных субъекта.
                </b-list-group-item>
            </b-list-group>

            <b-row class="mb-20 privacy-text-header">
                13. Взаимодействие с субъектом персональных данных
            </b-row>

            <b-row class="mb-20 privacy-text">
                Общество организовывает процессы взаимодействия с субъектами персональных данных таким образом, 
                чтобы субъект мог обратиться в Общество по всем предусмотренным в законодательстве Российской Федерации вопросам, связанным с обработкой его персональных данных.
            </b-row>

            <b-row class="mb-20 privacy-text">
            При оформлении субъектом обращений и запросов по вопросам обработки персональных данных рекомендуется использовать типовые формы, которые приведены в Приложениях А – Д  к настоящей Политике.
            </b-row>

            <b-row class="mb-20 privacy-text">
            Субъект персональных данных может обратиться в Общество по следующим каналам связи:
            </b-row>

            <b-list-group class="mb-20">
                <b-list-group-item>
                    по электронной почте на адрес:<a href="mailto:privacy@theMay.com"> privacy@theMay.com</a>;
                </b-list-group-item>
                <b-list-group-item>
                    по почтовому адресу: 109235, г. Москва, Проектируемый проезд 4294, д. 19, стр. 11.
                </b-list-group-item>
            </b-list-group>

            <b-row class="mb-20 privacy-text">
            Обращение или запрос субъекта в виде электронного документа должен быть подписан простой электронной подписью (простой электронной подписью будет являться фамилия, имя, отчество субъекта и адрес электронной почты). 
            </b-row>

            <b-row class="mb-20 privacy-text">
            Для выполнения запроса субъекта на получение информации об обрабатываемых персональных данных Общество может потребовать дополнительную информацию:
            </b-row>

            <b-list-group class="mb-20">
                <b-list-group-item>
                    номер основного документа, удостоверяющего личность субъекта персональных данных или его представителя, сведения о дате выдачи указанного документа и выдавшем его органе;
                </b-list-group-item>
                <b-list-group-item>
                    сведения, подтверждающие участие субъекта персональных данных в отношениях с 
                    Обществом (номер договора, дата заключения договора, условное словесное обозначение и (или) иные сведения), либо сведения, иным образом подтверждающие факт обработки персональных данных.
                </b-list-group-item>
            </b-list-group>

            <b-row class="mb-20 privacy-text-header">
                14. Контроль
            </b-row>

            <b-row class="mb-20 privacy-text">
            В Обществе проводится внутренний контроль (аудит) соответствия процессов обработки персональных данных требованиям законодательства Российской Федерации. Контроль проводится в случаях:
            </b-row>

            <b-list-group class="mb-20">
                <b-list-group-item>
                    создания новых процессов обработки персональных данных или внесения изменений в существующие процессы;
                </b-list-group-item>
                <b-list-group-item>
                    создания новых ИСПДн или внесения изменений в существующие ИСПДн;
                </b-list-group-item>
                <b-list-group-item>
                    изменения законодательства Российской Федерации, затрагивающего процессы обработки персональных данных в Обществе;
                </b-list-group-item>
                <b-list-group-item>
                    проведения ежегодных внутренних контрольных мероприятий на предмет оценки соответствия процессов обработки персональных данных требованиям законодательства Российской Федерации.
                </b-list-group-item>
            </b-list-group>
        </b-container>
    </div>
</template>
<script>
import '@/assets/styles/privacy.css'

export default {
    
}
</script>